import {
	Camera,
	CameraResultType,
	CameraSource,
	Photo,
} from "@capacitor/camera";
import { map, reject, replace } from "lodash";
import { useState } from "react";
import { from, map as rx_map, Observable, switchMap } from "rxjs";

//@ts-ignore
import ImageBlobReduce from "image-blob-reduce";
//@ts-ignore
import Pica from "pica";

const pica = Pica({ features: ["js", "wasm", "cib"] });
const reduce = new ImageBlobReduce({ pica });

export interface UserPhoto {
	blobPath?: string;
	filepath: string;
	isOcr?: boolean;
	metadata?: { [key: string]: string };
}

const defaultQuality = 25;

export function usePhotoGallery(existingPhotos: UserPhoto[] = []) {
	const [photos, setPhotos] = useState<UserPhoto[]>(existingPhotos);

	function takePhoto(): Observable<UserPhoto> {
		return from(
			Camera.getPhoto({
				resultType: CameraResultType.Uri,
				source: CameraSource.Camera,
				quality: defaultQuality,
			})
		).pipe(
			switchMap((cameraPhoto: Photo) => {
				return from(fetch(cameraPhoto.webPath!));
			}),
			switchMap((response: any) => {
				return from(response.blob());
			}),
			switchMap((blob) => {
				return from(reduce.toBlob(blob, { max: 1400 }));
			}),
			rx_map((blob: any) => {
				const fileName = `new-photo-${new Date().getTime()}.jpeg`;
				const savedPhoto = {
					blobPath: window.URL.createObjectURL(blob),
					filepath: fileName,
				};
				return savedPhoto;
			})
		);
	}

	function savePhoto(imageWebPath: string): Observable<UserPhoto> {
		return from(fetch(imageWebPath)).pipe(
			switchMap((response: any) => {
				return from(response.blob());
			}),
			switchMap((blob) => {
				return from(reduce.toBlob(blob, { max: 1400 }));
			}),
			rx_map((blob: any) => {
				const fileName = `new-photo-${new Date().getTime()}.jpeg`;
				const savedPhoto = {
					blobPath: window.URL.createObjectURL(blob),
					filepath: fileName,
				};
				return savedPhoto;
			})
		);
	}

	function removePhoto(filepath: string) {
		setPhotos(
			reject(photos, (photo: UserPhoto) => photo.filepath === filepath)
		);
	}

	function removeAndTakeAgain(photo: UserPhoto) {
		const { filepath } = photo;

		const newPhotos = reject(
			photos,
			(photo: UserPhoto) => photo.filepath === filepath
		);

		return from(
			Camera.getPhoto({
				resultType: CameraResultType.Base64,
				source: CameraSource.Camera,
				quality: defaultQuality,
			})
		).pipe(
			rx_map((cameraPhoto: Photo) => {
				const fileName = `new-photo-${new Date().getTime()}.jpeg`;
				const savedPhoto = {
					base64String: cameraPhoto.base64String,
					filepath: fileName,
				};
				setPhotos([savedPhoto, ...newPhotos]);
				return savedPhoto;
			})
		);
	}

	// function updatePhoto(updatedPhoto: UserPhoto) {
	// 	setPhotos(
	// 		map(photos, (photo) => {
	// 			if (photo.filepath === updatedPhoto.filepath) {
	// 				return {
	// 					...photo,
	// 					...updatedPhoto,
	// 				};
	// 			}
	// 			return photo;
	// 		})
	// 	);
	// }

	// function toggleOcr(filename: string) {
	// 	setPhotos(
	// 		map(photos, (photo) => {
	// 			return {
	// 				...photo,
	// 				isOcr: photo.filepath === filename ? !photo.isOcr : false,
	// 			};
	// 		})
	// 	);
	// }

	return {
		photos,
		removePhoto,
		removeAndTakeAgain,
		savePhoto,
		setPhotos,
		takePhoto,
		// toggleOcr,
		// updatePhoto,
	};
}
